import { ESpecialPromosBlocksTypes } from 'shared/actions/specialPromosBlocks/actions';
import { type TReduxActions } from 'shared/types/redux';
import { type ISpecialPromosBlocks } from 'shared/types/specialPromosBlocks';

const defaultSpecialPromosBlocksInitialState: ISpecialPromosBlocks = {
  banks: [],
  developerAwards: null,
  developerRatings: null,
  facts: [],
  mortgageBanner: null,
  mortgageCalculator: null,
  newbuildingsPlusBlocksPik: [],
  phone: '',
};

export function specialPromosBlocksReducer(
  state: ISpecialPromosBlocks = defaultSpecialPromosBlocksInitialState,
  action: TReduxActions,
): ISpecialPromosBlocks {
  switch (action.type) {
    case ESpecialPromosBlocksTypes.ESpecialPromosBlocksRefresh:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
